module.exports = __webpack_public_path__ + "d75bb538628fe2158d70069a612a4f9f.svg";